import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Ura Advisory',
    shortName: 'Ura',
    description: 'AI-powered tax, finance and business transformation firm in Kosovo, serving local and international businesses.',
    url: process.env.NEXT_PUBLIC_SITE_URL || 'https://ura-advisory.modulify.website',
    city: 'Prishtina',
    country: 'XK',
    links: {
        linkedin: '',
        x: ''
    }
}
